import { FC } from 'react';
import { Box, Button, Fade, Typography, useTheme, Divider, Paper } from '@mui/material';
import { CheckCircle, Login, MarkEmailRead } from '@mui/icons-material';
import { useNavigate } from 'react-router';

const RegistrationFormSuccess: FC = () => {
	const theme = useTheme();
	const navigate = useNavigate();

	const isMyPolicy = import.meta.env.VITE_AUTH_REALM === 'MyPolicy';

	const supportCopy = () => {
		if (isMyPolicy) {
			return (
				<>
					Didn&apos;t receive the email? Check your spam folder or please contact our customer service team on{' '}
					<a href='tel:03301002337'>0330 100 2337</a> if it doesn&apos;t arrive within 5 minutes.
				</>
			);
		} else {
			return (
				<>
					Didn&apos;t receive the email? Check your spam folder or contact our support team via the web chat if it
					doesn&apos;t arrive within 5 minutes.
				</>
			);
		}
	};

	return (
		<Fade in timeout={800}>
			<Paper
				elevation={2}
				sx={{
					mt: 2,
					textAlign: 'center',
					mx: 'auto',
					borderRadius: '8px',
					overflow: 'hidden',
					maxWidth: '550px',
				}}
			>
				{/* Top section with icon */}
				<Box
					sx={{
						pt: 5,
						pb: 3,
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<CheckCircle
						sx={{
							fontSize: 80,
							color: theme.palette.success.main,
							mb: 3,
						}}
					/>
					<Typography
						variant='h5'
						sx={{
							fontWeight: 600,
							color: theme.palette.text.primary,
						}}
					>
						Account Registration Successful
					</Typography>
				</Box>

				<Divider />

				{/* Content section */}
				<Box sx={{ px: 5, py: 2 }}>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							mb: 3,
							py: 2,
						}}
					>
						<MarkEmailRead
							color='primary'
							sx={{
								mr: 1.5,
								fontSize: '2rem',
								color: theme.palette.success.main,
							}}
						/>
						<Typography
							variant='body1'
							sx={{
								fontWeight: 600,
								fontSize: '1.2rem',
								color: theme.palette.success.main,
							}}
						>
							Verification email sent
						</Typography>
					</Box>

					<Typography
						variant='body1'
						sx={{
							mb: 4,
							color: theme.palette.text.secondary,
							lineHeight: 1.6,
						}}
					>
						We&apos;ve sent a verification link to your email address. Please check your inbox and verify your account.
					</Typography>

					<Box
						sx={{
							mb: 4,
							py: 2.5,
							px: 3,
							backgroundColor: theme.palette.grey[100],

							textAlign: 'left',
						}}
					>
						<Typography
							variant='body1'
							sx={{
								color: theme.palette.text.secondary,
								lineHeight: 1.6,
							}}
						>
							{supportCopy()}
						</Typography>
					</Box>

					<Button
						variant='contained'
						color='primary'
						size='large'
						sx={{
							py: 1.5,
							px: 4,
						}}
						fullWidth
						startIcon={<Login />}
						onClick={() => navigate('/portal/home')}
					>
						Proceed to Login
					</Button>
				</Box>
			</Paper>
		</Fade>
	);
};

export default RegistrationFormSuccess;
